import axios from "axios";
import domain from '@/util/domain.js';

var host = domain();
const headers = { "Content-Type": "application/json" };

//? Integrando ao Vue
export default {
  install(Vue) {
    Vue.prototype.$webhook = async (action, userData) => {
      //! ATENÇÃO - Caso tenham novos webhooks
      //? 1 - Adicionar domínio do Operador em (mapAuthorizedDomainWebhookSendMessage)
      //? 2 - Adicionar a URL do Lambda em (lambdaURLs) onde a
      //? "Chave" é a "Action" e o "Valor" a "URL do Lambda"
      //? 3 - Adicionar a configuração do body em (mapBodyByAction) onde a
      //? "Chave" é a "Action" e o "Valor" o "body"
      const mapAuthorizedDomainWebhookSendMessage = [
        "bets88",
        "betinterativovip",
      ];

      if (mapAuthorizedDomainWebhookSendMessage.includes(host)) {
        return new Promise(function (resolve, reject) {
          const lambdaURLs = {
            // Stack sga-lambda-webhooks-prod (us-east-2)
            sendMessage: "https://9cz5okmou4.execute-api.us-east-2.amazonaws.com/sendMessageWebhook",
          };

          const mapBodyByAction = {
            sendMessage: {
              userData: {
                "nome": userData.nome,
                "telefone": "55" + userData.celular,
                "email": userData.email,
              },
            },
          };

          axios.post(
            lambdaURLs[action],
            { domain: host, ...mapBodyByAction[action] },
            { headers }
          ).then((resp) => resolve(resp)).catch((err) => reject(err));
        });
      }

      return;
    }
  }
}